import { useState } from "react";

//ui
import { Grid, Stack, Typography } from "@mui/material";
import MainCard from "ui-component/cards/MainCard";
import Button from "@mui/material/Button";

//project imports
import { gridSpacing } from "store/constant";
import ReportsTable from "./ReportsTable";
import SearchBar from "ui-component/SearchBar";
import { StatusFilterDialog } from "./StatusFilterDialog";
import { useAppDispatch, useAppSelector } from "store/hooks";

import {
  selectReport,
  setSearchText,
  setFilter,
} from "store/slice/reportSlice";

// ==============================|| USER LIST STYLE 1 ||============================== //

const Reports = () => {
  const dispatch = useAppDispatch();
  const [statusFilterOpen, setStatusFilterOpen] = useState<boolean>(false);

  const { searchText } = useAppSelector(selectReport);

  const handleStatusFilterOpen = () => {
    setStatusFilterOpen(true);
  };

  const handleStatusFilterClose = (filter?: "active" | "disabled") => {
    setStatusFilterOpen(false);
    // if (filter) {
    //   dispatch(setFilter(filter || ""));
    //   // perform search/filter action with selected filter here
    // }
  };
  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          sx={{
            backgroundColor: "#fff",
            padding: "30px",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
          }}
        >
          <Grid
            container
            direction="row"
            spacing={2}
            alignItems="center"
          >
            <Grid item md={8}>
              <Typography variant="h3" gutterBottom>
                Report Users
              </Typography>
            </Grid>
            <Grid item md={4}>
              <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                spacing={2}
              >
                <Button
                  size="large"
                  color="primary"
                  variant="outlined"
                  className="fixed-width"
                  onClick={handleStatusFilterOpen}
                >
                  Filter
                </Button>
                <SearchBar
                  searchText={searchText}
                  setSearchText={setSearchText}
                />
              </Stack>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <StatusFilterDialog
            open={statusFilterOpen}
            onClose={handleStatusFilterClose}
          />
          <ReportsTable />
        </Grid>
      </Grid>
    </>
    // <MainCard sx={{ pt: 1.5 }} content={false}>
    //   <ReportsTable />
    // </MainCard>
  );
};

export default Reports;
